import { useCallback } from "react";
import { CustomModal } from "../../../../../../../../lib/CustomModal";
import { FormItems } from "./components/FormItems";
import "./styles.scss";

type TaxModalProps = {
  open: boolean;
  accountNumber: number;
  years: number[];
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
};

export const TaxModal = ({
  open,
  accountNumber,
  years,
  setOpen,
}: TaxModalProps) => {
  const cancel = useCallback(() => setOpen(false), [setOpen]);

  return (
    <CustomModal
      isModalOpen={open}
      setIsModalOpen={setOpen}
      titleText="Select a Year"
      headerClass="processing-print-modal--header"
      modalClass="processing-print-modal select-year-modal"
      width={300}
      destroyOnClose
    >
      <FormItems accountNumber={accountNumber} years={years} cancel={cancel} />
    </CustomModal>
  );
};
